import React, { Suspense, useEffect, useState } from "react";
import Banner from "../components/Banner";
import { lazy } from "react";

const Faq = lazy(() => import("../components/Faq.js"));
const Privileges = lazy(() => import("../components/Privileges.js"));
const Footer = lazy(() => import("../components/Footer.js"));

function Homepage() {
  const [executed, setExecuted] = useState(false);
  const [syncADL, setSyncADL] = useState(0);

  useEffect(() => {
    // Inject gtag.js only once
    if (!document.getElementById("gtag-js")) {
      const script = document.createElement("script");
      script.id = "gtag-js";
      script.async = true;
      script.src = "https://www.googletagmanager.com/gtag/js?id=AW-848956189"; // only one is needed
      document.head.appendChild(script);
    }

    const initGtag = () => {
      window.dataLayer = window.dataLayer || [];

      function gtag() {
        window.dataLayer.push(arguments);
      }

      window.gtag = gtag;

      // Initialize gtag with both Ads tracking IDs
      gtag("js", new Date());
      gtag("config", "AW-818835661");
      gtag("event", "conversion", {
        send_to: "AW-818835661/ZHDsCInX3v0aEM3huYYD",
      });

      gtag("event", "conversion", {
        allow_custom_scripts: true,
        send_to: "DC-8971752/invmedia/hhiu-2+standard",
      });
      gtag("config", "AW-848956189");
      // gtag("config", "AW-818835661");
      gtag("config", "AW-858657413");
    };

    // Initialize if already loaded, else wait for it
    if (window.gtag) {
      window.gtag("config", "AW-818835661");
      window.gtag("event", "conversion", {
        send_to: "AW-818835661/ZHDsCInX3v0aEM3huYYD",
      });

      window.gtag("event", "conversion", {
        allow_custom_scripts: true,
        send_to: "DC-8971752/invmedia/hhiu-2+standard",
      });
      window.gtag("config", "AW-848956189");
      // window.gtag("config", "AW-818835661");
      window.gtag("config", "AW-858657413");
    } else {
      const existingScript = document.getElementById("gtag-js");
      existingScript?.addEventListener("load", initGtag);
    }
  }, []);

  return (
    <>
      <Suspense fallback={<>Loading...</>}>
        <Banner />
        <Privileges />
        <Faq />
        <Footer />
      </Suspense>
    </>
  );
}

export default Homepage;
